import { render, staticRenderFns } from "./DescriptionTabOfPublicTender.vue?vue&type=template&id=73ce8b8a&scoped=true&"
import script from "./DescriptionTabOfPublicTender.vue?vue&type=script&lang=js&"
export * from "./DescriptionTabOfPublicTender.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionTabOfPublicTender.vue?vue&type=style&index=0&id=73ce8b8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ce8b8a",
  null
  
)

export default component.exports